import { styled } from '@mui/material';

const ContentUpload = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledActionsHeader = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledErrorUpload = styled('div')`
  margin-bottom: 24px;
  padding: 0 160px;
`;

export { ContentUpload, StyledActionsHeader, StyledErrorUpload };
